import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ModalContainer = ({ 
  isOpen, 
  onClose, 
  title, 
  ContentComponent, // The variable holding the component
  componentProps = {}, // Data to pass into that component
  maxWidth = 'sm' 
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth={maxWidth} 
    sx={{
        top:'100px',
        padding:"-20px"
    }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent dividers>
        {/* We render the component variable here and spread the props */}
        {ContentComponent ? (
          <ContentComponent {...componentProps} onDone={onClose} />
        ) : (
          "No component provided"
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalContainer;